import { render, staticRenderFns } from "./complaint-investigation-tab.vue?vue&type=template&id=e1e4392e"
import script from "./complaint-investigation-tab.vue?vue&type=script&lang=js"
export * from "./complaint-investigation-tab.vue?vue&type=script&lang=js"
import style0 from "./complaint-investigation-tab.vue?vue&type=style&index=0&id=e1e4392e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports